import { render } from "./DesignTemplate.vue?vue&type=template&id=47062c12&scoped=true"
import script from "./DesignTemplate.vue?vue&type=script&lang=js"
export * from "./DesignTemplate.vue?vue&type=script&lang=js"

import "./DesignTemplate.vue?vue&type=style&index=0&id=47062c12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47062c12"

export default script